import { render, staticRenderFns } from "./RelatorioLogTurma.vue?vue&type=template&id=1e9325a2"
import script from "./RelatorioLogTurma.vue?vue&type=script&lang=js"
export * from "./RelatorioLogTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports